import React, { useEffect, useState } from 'react';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Button,
    FormControl,
    FormLabel,
    Input,
    Select,
    useDisclosure,
    // useToast,
} from '@chakra-ui/react';
import CommessaPage from './CommessaPage';
// import axios from 'axios';

const CommessaModal = ({ commessa, isOpen, onClose }) => {
    const [name, setName] = useState('');
    const [start, setStart] = useState('');
    const [end, setEnd] = useState('');
    const [total_amount, setTotalAmount] = useState(0.0);
    const [to_be_invoiced, setToBeInvoiced] = useState(0.0);
    const [status, setStatus] = useState('pending');

    useEffect(() => {
        if (commessa) {
            setName(commessa.name);
            setStart(commessa.start);
            setEnd(commessa.end);
            setTotalAmount(commessa.total_amount);
            setToBeInvoiced(commessa.to_be_invoiced);
            setStatus(commessa.status);
        }
    }, [commessa]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        let commessa = {
            name: name,
            start: start,
            end: end,
            total_amount: total_amount,
            to_be_invoiced: to_be_invoiced,
            status: status
        };

        // onAssetChanged(commessa);
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} size='full'>
            <ModalOverlay />
            <ModalContent>
                <form onSubmit={handleSubmit}>
                    <ModalHeader>{name}</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>

                        <CommessaPage />

                    </ModalBody>
                    <ModalFooter>
                        <Button colorScheme="teal" mr={3} type="submit">
                            Salva
                        </Button>
                        <Button variant="ghost" onClick={onClose}>
                            Annulla
                        </Button>
                    </ModalFooter>
                </form>
            </ModalContent>
        </Modal>
    );
};

export default CommessaModal;